import React from 'react';
import './stylesDetailDatafacturacion.scss';

export const DetailDataFacuracion = ({ label = '', data = [], children = null}) => {  
  return (
    <div className="border mx-5 mt-5 mb-5">
      <div className="row m-3">
        <div className="col-md-12 ">
          <h2 className="text-mex">{label}</h2>
        </div>
      </div>
      {data?.map((item) => (
        <StructureDetail label={item?.label} value={item?.value} />
      ))}
      {children}
    </div>
  );
};

export default DetailDataFacuracion;


const StructureDetail = ({ label = '', value = '' }) => {
  return (
    <div className="row m-3">
        <div className="col-md-4 ">
          <h3 className='text-mex'>{label}: </h3>
        </div>
        <div className="col-md-8 detail-font ">{value}</div>
      </div>
  );
};